import { FC } from 'react';
import { Slider } from '../../components/Slider';

export type ICareEventTimeSliderProps = {
    'data-id'?: string;
    hours: number;
    activeColor?: string;
    onChange: (val: number) => void;
};

export const CareEventTimeSlider: FC<ICareEventTimeSliderProps> = ({ 'data-id': dataId, hours, activeColor, onChange }) => {
    return (
        <Slider
            data-type="care-hours-slider"
            data-id={dataId}
            min={0}
            max={24}
            steps={[0, 20, 40, 60, 80, 100, 120, 130, 140, 150, 160, 170, 180, 185, 190, 195, 200, 205, 210, 215, 220, 225, 230, 235, 240]}
            value={hours}
            activeColor={activeColor}
            onChange={onChange}
            showLabel
            labelFormatter={h => `${h} hr${h !== 1 ? 's' : ''}`}
        />
    );
};
